<template>
  <div class="user-list">
    <div class="seach">
      <el-row>
        <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status"
           @change="getUserStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="搜索昵称或手机号码"
            v-model="search.keywords"
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="tableLoading"> 
      <div class="mt20">
        <span class="little-title">用户列表（{{resultData.count}}）条</span>
      </div>
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column label="头像/昵称">
          <template slot-scope="scope">
            <div class="user-info">
              <img class="guests-avatar" :src="scope.row.user_pfrofile_photo" alt="头像" />
              <span class="vm">{{scope.row.wechat_nick_name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" ></el-table-column>
        <el-table-column prop="created_at" label="用户创建时间"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="userDescript(scope.row)">详情</el-button>
            <el-button type="text" size="mini" @click="privateMessage(scope.row,'1')">私人消息</el-button>
            <el-button v-if="scope.row.state==1" type="text" size="mini" @click="moveBlacklist(addUserBlack(),{user_id:scope.row.user_id,state:2},initUserList)">移入黑名单</el-button>
            <el-button v-if="scope.row.state==2" type="text" size="mini" @click="moveBlacklist(addUserBlack(),{user_id:scope.row.user_id,state:1},initUserList)">移除黑名单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
      <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
      <PrivateMessage
        :privateVisible.sync="privateVisible"
        :private_info="private_info"
        :messageType="messageType"
        @uploadStatus="uploadStatus"
        :isEdit="false"
      ></PrivateMessage>
    </div>
  </div>
</template>

<script>
//发送私人或者全员消息弹框
import PrivateMessage from "./components/private-message";

//引入混合mixins模式
import user_mixins from "./components/user-mixins.js";

import { _userList, _addUserBlack } from "@/api/user.js";

export default {
  created() {
    this.initUserList();
  },
  mixins: [user_mixins],
  components: {
    PrivateMessage
  },
  data() {
    return {
      tableLoading:false,
      //查询信息
      search: {
        page: 1,
        size: 10,
        keywords: "",
        status: "0",
      },
      options: [
        {
          label: "全部",
          value: "0"
        },
        {
          label: "已消费",
          value: "1"
        },
        {
          label: "黑名单",
          value: "2"
        },
      ],
      // name type num money date
      resultData:{}
    };
  },
  methods: {
    // 用户详情：
    userDescript(item) {
      let routeData = this.$router.resolve({
        path: `/user/user-descript`,
        query:{user_id:item.user_id},
        params:{info:item}
      });
      window.open(routeData.href, "_blank");
    },
    getUserStatus(){
      this.chearSearchState();
      this.initUserList();
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.initUserList();
    },
    seachList(){
      this.chearSearchState();
      this.initUserList();
    },
    //子组件成功之后刷新页面
    uploadStatus(val){
      if(val){
        this.initUserList();
      }
    },
    //加入黑名单
    addUserBlack(){
      return _addUserBlack;
    },
    //加载用户列表
    initUserList() {
      this.tableLoading=true;
      let data={
         page: this.search.page,
          size: 10,
          keywords: this.search.keywords,
          state: this.search.status
      }
      if(this.search.keywords==""){
        delete data["keywords"]
      }
      _userList({
        params:data
      }).then(res => {
        this.tableLoading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.seach {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.user-info {
  .guests-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>